<template>
  <div class="md-layout">
    <div class="md-layout md-layout-item md-size-50 md-medium-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-brand">
          <div class="card-icon">
            <md-icon>visibility</md-icon>
          </div>
          <h3 class="title">Pregled</h3>
          <md-button
            class="md-just-icon md-round modal-default-button md-simple"
            @click="showPreview = !showPreview"
          >
            <md-icon v-if="showPreview"> minimize </md-icon>
            <md-icon v-else> maximize </md-icon>
          </md-button>
        </md-card-header>
        <md-card-content
          id="invoice-preview"
          class="invoice-body"
          v-show="showPreview"
        >
        </md-card-content>
        <md-card-actions v-if="showPreview" md-alignment="right">
          <md-button class="md-info" @click="downloadInvoicePdf">
            <md-icon> picture_as_pdf </md-icon>
            Preuzmi PDF
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
    <div class="md-layout-item md-size-50 md-medium-size-100">
      <ValidationObserver slim v-slot="{ invalid }">
        <md-card class="md-layout md-layout-item md-size-100">
          <md-card-header class="md-card-header-icon md-card-header-brand">
            <div class="card-icon">
              <md-icon>request_page</md-icon>
            </div>
            <h3 class="title">Faktura</h3>
            <md-button
              class="md-just-icon md-round modal-default-button md-simple"
              @click="closeInvoice"
            >
              <md-icon> clear </md-icon>
            </md-button>
          </md-card-header>

          <md-card-content class="md-layout flex-end">
            <md-field class="md-layout-item md-size-10">
              <label> Broj </label>
              <md-input type="number" v-model="invoiceNumber"> </md-input>
            </md-field>
            <md-field class="md-layout-item md-size-35">
              <label> Rok </label>
              <md-datepicker v-model="deadline"> </md-datepicker>
            </md-field>
            <md-field class="md-layout-item md-size-40">
              <search-drop-down
                title="Klijent"
                :items="clients"
                :defaultValue="client.name || ''"
                @updatedInput="searchClients"
                @selected="selectClient"
              />
            </md-field>
            <md-field class="md-layout-item md-size-15">
              <label> PDV (%) </label>
              <md-select v-model="vat" @input="onVatUpdated">
                <md-option value="0.21"> 21% </md-option>
                <md-option value="0.07"> 7% </md-option>
                <md-option value="0.0"> 0% </md-option>
              </md-select>
            </md-field>
          </md-card-content>
        </md-card>
        <InvoiceItem
          ref="invoiceItem"
          v-for="(item, index) in items"
          :key="item.id"
          :index="index + 1"
          :item.sync="items[index]"
          :vat="vat"
          :itemUnits="itemUnits"
          @update="onItemUpdated"
          @delete-item="deleteItem"
        />
        <div
          v-if="items.length < 10"
          @click="addItem"
          class="md-layout-item md-size-100 new-item"
        >
          <p class="center-text">
            <md-icon> add_circle </md-icon>
            Dodaj stavku
          </p>
        </div>
        <md-card class="additional-document-card">
          <md-card-content>
            <ValidationProviderExtended
              name="Dodatni dokument"
              rules="website"
            >
              <label> Dodatni dokument </label>
              <md-input v-model="additionalDocumentUrl" type="text"> </md-input>
            </ValidationProviderExtended>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-content class="md-layout">
            <md-field class="md-layout-item md-size-100">
              <label> Napomena </label>
              <md-textarea v-model="comment"> </md-textarea>
            </md-field>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="md-layout flex-column">
              <div class="prices">
                <h3 class="md-layout-item">
                  Ukupno PDV {{ priceDisplay(totalVatAmount) }}
                </h3>
                <h3 class="md-layout-item">
                  Ukupna cijena {{ priceDisplay(totalPrice) }}
                </h3>
              </div>
              <div class="md-layout md-layout-item invoice-actions">
                <div class="md-layout-item md-size-25">
                  <md-checkbox v-model="printComment">
                    Štampaj napomenu
                  </md-checkbox>
                </div>
                <div class="md-layout md-layout-item">
                  <md-button
                    @click="saveInvoice"
                    class="md-success"
                    :disabled="invalid || sentForVat"
                  >
                    <md-icon> save </md-icon>
                    Sačuvaj
                  </md-button>
                </div>
              </div>
            </div>
          </md-card-actions>
        </md-card>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import api from '../api/api.js';
import services from '@/api/services';
import InvoiceItem from '@/components/InvoiceItem.vue';
import ValidationProviderExtended from '@/components/ValidationProviderExtended.vue';
import Swal from 'sweetalert2';
import { getAsDate, uuid } from '@/utils/helpers';
import { arrayToObject } from '../utils/helpers.js';
export default {
  components: {
    InvoiceItem,
    ValidationProviderExtended,
  },
  props: {
    id: [Number, String],
  },
  computed: {
    itemsWithUnits() {
      return this.items.map(item => ({
        ...item,
        unit: parseInt(this.itemUnits[item.unitId]),
      }));
    },
    requestData() {
      return {
        id: this.id,
        invoiceNumber: this.invoiceNumber,
        deadline: getAsDate(this.deadline),
        clientId: this.client.id,
        comment: this.comment,
        additionalDocumentUrl: this.additionalDocumentUrl,
        printComment: this.printComment,
        items: this.itemsWithUnits,
        vat: this.vat,
        totalVatAmount: this.totalVatAmount,
        totalPrice: this.totalPrice,
      };
    },
  },
  data() {
    return {
      invoiceNumber: null,
      clients: [],
      client: {},
      deadline: new Date().setDate(new Date().getDate() + 30),
      items: [],
      itemUnits: {},
      totalVatAmount: '',
      totalPrice: '',
      comment: '',
      additionalDocumentUrl: '',
      iic: null,
      sentForVat: false,
      printComment: false,
      showPreview: false,
      creatorId: null,
      vat: '0.21',
    };
  },
  methods: {
    getInvoice() {
      return api
        .get(services.invoices.getInvoice, { getInvoice: true, id: this.id })
        .then(data => {
          this.invoiceNumber = data.invoiceNumber;
          this.client.id = data.clientId;
          this.client.name = data.clientName;
          this.deadline = data.deadline;
          this.totalVatAmount = data.totalVatAmount;
          this.totalPrice = data.totalPrice;
          this.vat = data.vat;
          this.comment = data.comment;
          this.additionalDocumentUrl = data.additionalDocumentUrl;
          this.iic = data.iic;
          this.sentForVat = data.sentForVat;
          this.printComment = data.printComment;
          this.creatorId = data.creatorId;
          this.items = data.items.map(item => ({ ...item, id: uuid() }));
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    addItem() {
      if (this.items.length >= 10) return;

      this.items.push({
        id: uuid(),
        name: '',
        amount: '10.0',
        unitDiscountedPrice: '1.0',
        unitPrice: '1.0',
        unitId: '1',
        vat: '0.21',
      });

      this.refreshInvoiceData();
    },
    downloadInvoice() {
      return api
        .post(services.invoices.getInvoiceBody, {
          downloadInvoice: true,
          id: this.id,
        })
        .then(data => {
          document.getElementById('invoice-preview').innerHTML = data;
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    deleteItem(index) {
      if (this.items.length <= 1) return;

      this.items.splice(index - 1, 1);
      this.refreshInvoiceData();
    },
    async refreshInvoiceData() {
      const { items, vat } = this.requestData;

      const invoiceData = await api.post(services.invoices.calculateInvoice, {
        items: JSON.stringify(items),
        vat,
      });

      this.items = invoiceData.items;
      this.totalVatAmount = invoiceData.totalVatAmount;
      this.totalPrice = invoiceData.totalPrice;
    },
    saveInvoice() {
      if (this.sentForVat) return;

      return Swal.fire({
        title: 'Sačuvaj fakturu?',
        text: `Da li ste sigurni da želite da sačuvate izmjene na fakturi br. ${this.invoiceNumber}?`,
        type: 'warning',
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Sačuvaj',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
        showCancelButton: true,
      }).then(({ value }) => {
        if (!value) return;

        api
          .post(services.invoices.saveInvoice, {
            saveInvoice: true,
            invoice: JSON.stringify(this.requestData),
          })
          .then(data => {
            if (data.id && this.$route.query.id !== data.id)
              this.$router.push({ path: 'invoices', query: { id: data.id } });

            this.$emit('saved-invoice', true);

            if (this.id) this.downloadInvoice();

            this.alertSuccess('Ažurirana faktura broj ' + this.invoiceNumber);
          })
          .catch(error => {
            this.alertError(error);
          });
      });
    },
    downloadInvoicePdf() {
      this.$parent.downloadInvoice({ id: this.id });
    },
    selectClient(value) {
      this.client = value;
    },
    searchClients(value) {
      api
        .get(services.getClient, {
          loadClient: true,
          clientName: value,
          isClient: true,
        })
        .then(data => {
          this.clients = data;
        });
    },
    async getItemUnits() {
      const itemUnits = await api.get(services.getItemUnits, {
        getItemUnits: true,
      });

      this.itemUnits = arrayToObject(itemUnits, ({ id, name }) => ({
        key: id,
        value: name,
      }));
    },
    closeInvoice() {
      this.$emit('close-invoice', true);
    },
    onVatUpdated() {
      for (const item of this.$refs.invoiceItem) {
        item.clearFields(['totalPrice']);
      }

      this.refreshInvoiceData();
    },
    onItemUpdated() {
      this.refreshInvoiceData();
    },
  },
  mounted() {
    (() => {
      if (this.id !== 0) {
        return this.getInvoice().then(() => {
          this.downloadInvoice();
        });
      } else {
        return Promise.resolve();
      }
    })().then(() => {
      this.getItemUnits();
    });

    if (this.invoiceNumber === null && this.$parent.metaData)
      this.invoiceNumber = this.$parent.metaData.maxNumber + 1;
  },
  watch: {
    id() {
      if (this.id === 0) return;

      this.getInvoice().then(() => {
        this.downloadInvoice();
      });
    },
  },
};
</script>
<style scoped lang="scss">
.new-item {
  height: 6em;
  border: 3px dashed #8a8a8a;
  margin: 15px 0;
  border-radius: 0.4em;
  cursor: pointer;
}
.center-text {
  text-align: center;
  margin-top: 2em;
}
.flex-column {
  flex-direction: column;
  gap: 3em;

  & > .prices {
    text-align: end;
  }
}
.invoice-actions {
  align-items: center;

  & > div {
    justify-content: flex-end;
    align-items: stretch;
    gap: 20px;
  }
}
.invoice-body {
  position: relative;
}
.flex-end {
  align-items: flex-end;
}
.additional-document-card .md-card-content {
  padding: 1.5rem;
}
</style>
